export const LOGIN_OR_SIGNUP_STEP = 0;
export const CONFIRM_LICENSE_STEP = 1;
export const PAYMENT_METHOD_STEP = 2;

export const ENTERPRISE_FORM_STEP = 3;

export const FIRST_STEP = LOGIN_OR_SIGNUP_STEP;
